<template>
    <div class="strategydetailmain">
        <div v-if="detailCompleted" class="strategydetail">
            <h3>{{ strategydetail.title }}</h3>
            <div class="item-label">
                <span v-for="(item, index) in strategydetail.tags" :key="index" v-if="item">{{item}}</span>
            </div>
            <p>投资逻辑：</p>
            <p>{{ strategydetail.logic }}</p>
            <div class="item-user">
                <div class="item-user-img right">
                    <img :src="strategydetail.avatarUrl">
                </div>
                <p class="right user">{{ strategydetail.userName }}</p>
            </div>
            <div class="strip"></div>
            <p>策略问句：</p>
            <p>{{ strategydetail.query }}</p>
            <p>回测参数：</p>
            <div class="question_model_normal" v-show="currentBacktestType === '1'">
                <div class="buy_layer">
                    <span class="car"></span>
                    <div class="moment">
                        <span>时机 : </span>
                        <span>开盘买入</span>
                    </div>
                    <div class="cycle">
                        <span>持股周期 : &nbsp</span>
                        <span>{{ strategydetail.daysForSaleStrategy }}</span>
                        <span>&nbsp天</span>
                    </div>
                    <div class="shares">
                        <span>持股上限 : &nbsp</span>
                        <span>{{ strategydetail.stockHoldCount }}</span>
                        <span>只</span>
                    </div>
                    <div class="shares">
                        <span>单日买入数 : &nbsp</span>
                        <span>{{ strategydetail.queryString.dayBuyStockNum ? strategydetail.queryString.dayBuyStockNum : strategydetail.stockHoldCount }}</span>
                        <span>只</span>
                    </div>
                    <div class="shares">
                        <span>资金量 : &nbsp</span>
                        <span>{{ strategydetail.queryString.capital ? strategydetail.queryString.capital : strategydetail.capital }}</span>
                    </div>
                </div>
                <div class="sell_layer_up">
                    <span class="car"></span>
                    <div class="target_profit">
                        <span>止盈 : </span>
                        <p style="margin: 0;">收益率 ≥ {{ strategydetail.upperIncome }} % 时坚定持有;直到最高收益回落 {{ strategydetail.fallIncome }} % </p>
                    </div>
                    <div class="stop_loss">
                        <span>止损 : </span>
                        <p style="margin: 0;">收益率 ≤ - {{ strategydetail.lowerIncome }} % </p>
                    </div>
                    <div class="position_control">
                        <span>仓位控制 : </span>
                        <span>满仓</span>
                    </div>
                </div>
            </div>
            <div class="question_model_market" style="margin-bottom: 30px;" v-show="currentBacktestType === '2'">
                <div class="buy_layer">
                    <span class="car"></span>
                    <div class="moment">
                        <span>时机 : </span>
                        <span>开盘买入</span>
                    </div>
                    <div class="cycle">
                        <span>持股周期 : &nbsp</span>
                        <span>{{ strategydetail.daysForSaleStrategy }}</span>
                        <span>&nbsp天</span>
                    </div>
                    <div class="shares">
                        <span>持股上限 : &nbsp</span>
                        <span>{{ strategydetail.stockHoldCount }}</span>
                        <span>只</span>
                    </div>
                    <div class="shares">
                        <span>单日买入数 : &nbsp</span>
                        <span>{{ strategydetail.queryString.dayBuyStockNum ? strategydetail.queryString.dayBuyStockNum : strategydetail.stockHoldCount }}</span>
                        <span>只</span>
                    </div>
                    <div class="shares">
                        <span>资金量 : &nbsp</span>
                        <span>{{ strategydetail.queryString.capital ? strategydetail.queryString.capital : strategydetail.capital }}</span>
                    </div>
                </div>
                <div class="market_title">
                    <p :class="currentBacktestType === '2' ? 'fwb' : ''">强势市场: </p>
                </div>
                <div class="sell_layer_up" :class="currentBacktestType === '2' ? 'mb0' : ''">
                    <span class="car"></span>
                    <div class="target_profit">
                        <span>止盈 : </span>
                        <p style="margin: 0;">收益率 ≥ {{ strategydetail.upperIncome }} % 时坚定持有;直到最高收益回落 {{ strategydetail.fallIncome }} % </p>
                    </div>
                    <div class="stop_loss">
                        <span>止损 : </span>
                        <p style="margin: 0;">收益率 ≤ - {{ strategydetail.lowerIncome }} % </p>
                    </div>
                    <div class="position_control">
                        <span>仓位控制 : </span>
                        <span>满仓</span>
                    </div>
                </div>
                <div class="market_title">
                    <p>弱势市场: </p>
                </div>
                <div class="sell_layer_down" :class="currentBacktestType === '2' ? 'mb0' : ''">
                    <span class="car"></span>
                    <div class="target_profit">
                        <span>止盈 : </span>
                        <p style="margin: 0;">收益率 ≥ {{ strategydetail.queryString.bearMarketUpperIncome }} % 时坚定持有;直到最高收益回落 {{ strategydetail.queryString.bearMarketFallIncome }} % </p>
                    </div>
                    <div class="stop_loss">
                        <span>止损 : </span>
                        <p style="margin: 0;">收益率 ≤ - {{ strategydetail.queryString.bearMarketLowerIncome }} % </p>
                    </div>
                    <div class="position_control">
                        <span>仓位控制 : </span>
                        <span>{{ positionTitle(strategydetail.buyPosition) }}</span>
                    </div>
                </div>
                <div class="market_title">
                    <p class="fl">市场信号: </p>
                </div>
                <div class="signalbox">
                    <div class="market_signal" v-for="item in marketsignals">
                        <p>{{ signalData[item] }}</p>
                    </div>
                </div>
            </div>
            <router-link :to="{name: 'strategybacktest', query: strategydetail.queryString}"><div class="modify" @click="buriedPoints">修改参数</div></router-link>
            <template v-if="isOwn">
                <div class="collect" @click="releaseBacktest(strategyId)" v-if="isPublish === 2">发布</div>
                <div class="alcollect" v-else>收藏数（{{ collectedNum }}）</div>
            </template>
            <template v-else>
                <div class="collect" @click="addCollection(strategyId)" v-show="!isCollected">收藏策略</div>
                <div
                    class="alcollect"
                    :class="iscancel ? 'cancel' : ''"
                    @click="removeCollection(strategyId)"
                    v-show="isCollected"
                    @mouseenter="iscancel = !iscancel"
                    @mouseleave="iscancel = !iscancel"
                    >{{iscancel ? '取消收藏' : '已收藏'}}</div>
            </template>
        </div>
        <template v-if="detailCompleted">
            <report-grade
                :strategy-id="strategyId"
                :transactiontype="currentBacktestType"
                :signal-data="signalData"
                :report-data="reportdata"
                :query="strategydetail.query">
            </report-grade>

            <backtest-analysis
                :transactiontype="currentBacktestType"
                :signal-data="signalData"
                :backtest-data="backtestAnalysisData"
                :max-winrate="reportdata.maxWinRate"
                :max-annualyield="reportdata.maxAnnualYield">
            </backtest-analysis>

            <strategy-select
                :show-pick="true"
                :strategy-id="strategyId"
                :transactiontype="currentBacktestType"
                :buy-position="parseInt(strategydetail.buyPosition)"
                :select-data="selectData"
                :query="strategydetail.query"
                :hold="'' + strategydetail.queryString.dayBuyStockNum ? strategydetail.queryString.dayBuyStockNum : strategydetail.stockHoldCount">
            </strategy-select>

            <profit-chart
                v-if="profitgraphCompleted"
                :backtest-id="id"
                :strategy-id="strategyId"
                :profit-data="cumulative"
                :transactiontype="currentBacktestType"
                :max-winrate="reportdata.maxWinRate"
                :max-annualyield="reportdata.maxAnnualYield"
                :day-select="dayselect"
                :market-signals="bestMarketsignals"
                :signal-data="signalData"
                :hs-data="Hsdata"
                :score-data="scoreData">
            </profit-chart>

            <change-rate-group
                v-if="profitgraphCompleted"
                :backtest-id="id"
                :strategy-id="strategyId"
                :profit-group-data="change"
                :transactiontype="currentBacktestType"
                :max-winrate="reportdata.maxWinRate"
                :day-select="dayselect"
                :market-signals="bestMarketsignals"
                :signal-data="signalData">
            </change-rate-group>

            <history-detail
                :backtest-id="id"
                :strategy-id="strategyId"
                :transactiontype="currentBacktestType"
                :max-winrate="reportdata.maxWinRate"
                :day-select="dayselect"
                :market-signals="bestMarketsignals"
                :signal-data="signalData"
                :min-date="tradeStartDate"
                :max-date="tradeEndDate"
                :my-bar-option="myBarOption">
            </history-detail>
        </template>
        <div class="comment" v-if="detailCompleted && isPublish === 1">
            <div class="comment_title">
                <p>策略评论</p>
            </div>
            <div class="comment_main">
                <div class="comment_content">
                    <textarea placeholder="你认为这策略如何..." v-model="comment" v-show="!isOwn"></textarea>
                    <p v-show="iscommentshow" >评论内容不能为空</p>
                    <div class="publish_comment" @click="commentClick"  v-show="!isOwn">{{ commentUploading ? '发布中…' : '发表评论' }}</div>
                    <div class="own-discuss-list">
                        <receive-discuss :pid="pid" :sid="parseInt(strategyId)"></receive-discuss>
                    </div>
                </div>
            </div>
        </div>
        <div class="testmain" v-show="isshowtestloading">
            <div class="testshadow"></div>
            <div class="testparallel">
                <div class="test-loading">
                    <span class="testing-icon"></span>
                    <span>正在加载，请耐心等待……</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable no-undef */
/* eslint-disable no-new */

    import changeRateGroup from '../strategybacktest/chart'
    import historyDetail from '../strategybacktest/history'
    import backtestAnalysis from '../strategybacktest/backtest-analysis'
    import strategySelect from '../strategybacktest/strategy-select'
    import profitChart from '../strategybacktest/profit-chart'
    import reportGrade from '../strategybacktest/report-grade'
    import receiveDiscuss from './receive-discuss'
    import axios from 'axios'
    var requestarr = []
    export default {
        name: 'strategydetail',
        components: {
            'change-rate-group': changeRateGroup,
            'history-detail': historyDetail,
            'backtest-analysis': backtestAnalysis,
            'strategy-select': strategySelect,
            'profit-chart': profitChart,
            'report-grade': reportGrade,
            'receive-discuss': receiveDiscuss
        },
        data () {
            var nowDate = this._getNowDate()
            return {
                myBarOption: {
                    barWidth: 9, // 滚动条宽度
                    barMarginRight: 3, // 垂直滚动条距离整个容器右侧距离单位
                    horizrailenabled: false // 是否显示水平滚动条
                },
                tradeStartDate: nowDate,
                tradeEndDate: nowDate,
                iscommentshow: false,
                isshowtestloading: false,
                detailCompleted: false,
                iscancel: false,
                isCollected: false,
                collectedNum: 0,
                isPublish: 2, // 2-未发布 1-发布
                isOwn: false, // 是否为当用用户的回测
                pid: 0,
                authorid: 0,
                id: '',
                currentBacktestType: '1',
                number: '',
                strategydetail: {},
                reportdata: {
                    maxAnnualYield: {},
                    maxWinRate: {}
                },
                signalData: {},
                scoreData: {},
                backtestdata: {},
                cumulative: [],
                change: [],
                Hsdata: [],
                selectData: null,
                comment: '',
                commentUploading: false,
                profitgraphCompleted: false // 图表数据请求完成
            }
        },
        computed: {
            buriedPoint () {
                return this.$buriedPoint.strategyDetails
            },
            totalPoint () {
                return this.$buriedPoint.totalPlatformAccess
            },
            strategyId () {
                return this.$route.params.id
            },
            dayselect () {
                return this.number.split(',')
            },
            marketsignals () {
                let marketsignal = []
                for (var key in this.backtestdata) {
                    marketsignal.push(key)
                }
                return marketsignal
            },
            // 取最优的两条
            backtestAnalysisData () {
                if (this.currentBacktestType === '1') {
                    return this.backtestdata
                } else {
                    var maxWinRate = this.reportdata.maxWinRate
                    var maxAnnualYield = this.reportdata.maxAnnualYield

                    let analysisData = {}
                    analysisData[maxWinRate[1]] = this.backtestdata[maxWinRate[1]]
                    analysisData[maxAnnualYield[1]] = this.backtestdata[maxAnnualYield[1]]
                    return analysisData
                }
            },
            // 取最优的两条
            bestMarketsignals () {
                if (this.currentBacktestType === '1') {
                    return this.marketsignals
                } else {
                    var maxWinRate = this.reportdata.maxWinRate
                    var maxAnnualYield = this.reportdata.maxAnnualYield
                    if (maxWinRate[1] === maxAnnualYield[1]) {
                        return [maxWinRate[1]]
                    } else {
                        return [maxWinRate[1], maxAnnualYield[1]]
                    }
                }
            }
        },
        created () {
            this.request(this.strategyId)
        },
        mounted () {
            window.TA.log({id: this.buriedPoint.pageAccess.replace('_square', '_square_' + this.strategyId), _sid: '__ths_001'})
            // window.TA.log({id: this.totalPoint, _sid: '__ths_002'})
            axios.get('/tradebacktest/menvdata').then((res) => {
                this.signalData = res.data.result.data
            }).catch(function (error) {
                self.$tip({message: (error ? error.message : '网络异常'), duration: 2000, type: 'error'})
            })
        },
        watch: {
            strategyId (id) {
                this.request(id)
            }
        },
        methods: {
            positionTitle (position) {
                position = parseInt(position)
                if (position === 0) {
                    return '空仓'
                } else if (position === 100) {
                    return '满仓'
                } else {
                    return '' + position + '%仓位'
                }
            },
            buriedPoints () {
                window.TA.log(this.buriedPoint.strategyParam.modifyParam.replace('_square', '_square_' + this.strategyId))
            },
            _getNowDate: function () {
                var now = new Date()
                var month = now.getMonth() + 1
                month = month < 10 ? '0' + month : month
                var date = now.getDate() < 10 ? '0' + now.getDate() : now.getDate()
                var nowDate = now.getFullYear() + '-' + month + '-' + date
                return nowDate
            },
            request (id) {
                var self = this
                var counts1 = axios.get('/strategysquare/detail', {params: {strategyId: id}})
                counts1.then((res) => {
                    return res.data
                }).then((data) => {
                    if (data.errorcode !== 0) {
                        if (data.errorcode === -410) {
                            self.$router.replace({name: 'strategysquare'})
                            return
                        }
                        self.$tip({message: data.errormsg ? data.errormsg : '获取策略详情失败', type: 'error'})
                    } else {
                        this.strategydetail = data.result
                        this.number = data.result.daysForSaleStrategy
                        this.id = data.result.key
                        this.pid = data.result.pid
                        this.authorid = data.result.authorId
                        this.tradeStartDate = data.result.startDate
                        this.tradeEndDate = data.result.endDate
                        this.isCollected = data.result.isCollected
                        this.collectedNum = data.result.collectedNum
                        this.isPublish = parseInt(data.result.isPublish)
                        this.isOwn = data.result.isOwn
                        this.currentBacktestType = data.result.menv ? '2' : '1'
                    }
                }).catch(function (error) {
                    self.$tip({message: (error ? error.message : '网络异常'), duration: 2000, type: 'error'})
                })

                requestarr.push(counts1)

                var counts2 = axios.get('/strategysquare/backtestresult', {params: {strategyId: id}})
                counts2.then((res) => {
                    return res.data
                }).then((data) => {
                    if (data.errorcode !== 0) {
                        if (data.errorcode === -410) {
                            self.$router.replace({name: 'strategysquare'})
                            return
                        }
                        self.$tip({message: data.errormsg ? data.errormsg : '获取策略详情失败', type: 'error'})
                    } else {
                        this.reportdata = data.result.statistics.reportData
                        this.backtestdata = data.result.analysis.backtestData
                    }
                }).catch(function (error) {
                    self.$tip({message: (error ? error.message : '网络异常'), duration: 2000, type: 'error'})
                })

                requestarr.push(counts2)

                this.isshowtestloading = true
                this.detailCompleted = false
                this.profitgraphCompleted = false
                axios.all(requestarr).then(axios.spread(() => {
                    self.$nextTick(function () {
                        self.chartdata()
                        self.pickdata()
                    })
                    this.isshowtestloading = false
                    this.detailCompleted = true
                }))
            },
            chartdata: function () {
                var self = this
                axios.get('/strategysquare/profitgraph', {params: {strategyId: this.strategyId}}).then((res) => {
                    return res.data
                }).then((data) => {
                    if (data.errorcode !== 0) {
                        self.$tip({message: data.errormsg ? data.errormsg : '获取图表失败', type: 'error'})
                    } else {
                        self.cumulative = data.result.profitRateLine
                        self.scoreData = data.result.rankScore
                        self.change = data.result.profitRatePie
                        self.Hsdata = data.result.HS300Line
                        self.profitgraphCompleted = true
                    }
                }).catch(function (error) {
                    self.$tip({message: (error ? error.message : '网络异常'), duration: 2000, type: 'error'})
                })
            },
            pickdata: function () {
                var self = this
                axios.get('/strategysquare/pickstock', {params: {strategyId: this.strategyId}}).then((res) => {
                    return res.data
                }).then((data) => {
                    if (data.errorcode !== 0) {
                        if (data.errorcode === -410) {
                            this.$router.replace({name: 'strategysquare'})
                            return
                        }
                        this.$tip({message: data.errormsg ? data.errormsg : '获取选股失败', type: 'error'})
                    } else {
                        this.selectData = data.result
                    }
                }).catch(function (error) {
                    self.$tip({message: (error ? error.message : '网络异常'), duration: 2000, type: 'error'})
                })
            },
            // 发布
            releaseBacktest (id) {
                var self = this

                this.$confirm({
                    'title': '您确定要发布该策略吗？',
                    'okBtnTitle': '确定',
                    'okBtnCallback': function (done) {
                        window.TA.log(self.buriedPoint.strategyParam.release.replace('_square', '_square_' + this.strategyId))
                        axios.post('/tradebacktest/release', {
                            id: id
                        }).then((res) => {
                            done()
                            if (res) {
                                if (res.data.errorcode !== 0 && res.data.errorcode !== -99) {
                                    self.$tip({message: res.data.errormsg ? res.data.errormsg : '发布失败', type: 'error'})
                                } else if (res.data.errorcode === -99) {
                                    self.$tip({message: '发布失败，您的同花顺账户暂未绑定手机号码', type: 'error'})
                                } else {
                                    self.$store.dispatch('myStrategy/requestTradeBacktest')
                                    self.$tip({message: '提交成功！正在审核中', type: 'success'})
                                    self.isPublish = 1
                                }
                            }
                        }).catch((error) => {
                            done()
                            self.$tip({
                                message: (error ? error.message : '发布失败'),
                                duration: 2000,
                                type: 'error'
                            })
                        })
                    }
                })
            },
            addCollection (id) {
                var self = this
                axios.post('/strategysquare/collect', {
                    strategyId: id
                }).then((res) => {
                    if (res) {
                        if (res.data.errorcode === 0) {
                            self.$tip({
                                message: '策略收藏成功',
                                duration: 2000,
                                type: 'success'
                            })
                            self.isCollected = true
                            self.$store.dispatch('myStrategy/requestCollectBacktest')
                        } else {
                            self.$tip({
                                message: (res.data.errormsg ? res.data.errormsg : '策略收藏失败'),
                                duration: 2000,
                                type: 'error'
                            })
                        }
                    }
                }).catch((error) => {
                    self.$tip({
                        message: (error ? error.message : '策略收藏失败'),
                        duration: 2000,
                        type: 'error'
                    })
                })
            },
            removeCollection (id) {
                var self = this
                axios.post('/strategysquare/uncollect', {
                    strategyId: id
                }).then((res) => {
                    if (res) {
                        if (res.data.errorcode === 0) {
                            self.$tip({
                                message: '策略取消收藏成功',
                                duration: 2000,
                                type: 'success'
                            })
                            self.$store.dispatch('myStrategy/requestCollectBacktest')
                        }
                        self.isCollected = false
                    }
                }).catch((error) => {
                    self.$tip({
                        message: (error ? error.message : '策略取消收藏失败'),
                        duration: 2000,
                        type: 'error'
                    })
                })
            },
            commentClick () {
                var self = this
                if (this.commentUploading) {
                    return
                }
                if (this.comment === '') {
                    this.iscommentshow = true
                } else {
                    window.TA.log(this.buriedPoint.strategyDiscuss.comment.replace('_square', '_square_' + this.strategyId))
                    this.commentUploading = true
                    axios.post('/sns/addcomment', {
                        pid: this.pid,
                        receiver_id: this.authorid,
                        content: this.comment
                    }).then((res) => {
                        if (!res.data.result) {
                            this.$tip({
                                message: '回复失败，请稍后再试',
                                duration: 2000,
                                type: 'error'
                            })
                        } else {
                            this.$tip({
                                message: '回复内容正在后台审核中',
                                duration: 2000,
                                type: 'success'
                            })
                            this.comment = ''
                            self.$store.dispatch('myStrategy/requestSendDiscuss')
                        }
                        this.commentUploading = false
                    }).catch((error) => {
                        this.$tip({
                            message: error ? error.message : '网络异常',
                            duration: 2000,
                            type: 'error'
                        })
                        this.commentUploading = false
                    })
                }
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    @import '../../scss/strategysquare/strategydetail.scss';
</style>



// WEBPACK FOOTER //
// src/components/strategysquare/strategydetail.vue